export { default as UniversalLoader } from './UniversalLoader';
